export const usageSymbol = Symbol.for("Pothos.isUsed");
export function wrapWithUsageCheck(obj) {
    const result = {};
    let used = true;
    Object.defineProperty(result, usageSymbol, {
        get() {
            return used;
        },
        set(value) {
            used = value;
        },
        enumerable: false
    });
    for (const key of Object.keys(obj)) {
        // only set to false if the object has keys
        used = false;
        Object.defineProperty(result, key, {
            enumerable: true,
            configurable: true,
            // eslint-disable-next-line @typescript-eslint/no-loop-func
            get() {
                used = true;
                return obj[key];
            }
        });
    }
    return result;
}
export function isUsed(obj) {
    return !(usageSymbol in obj) || obj[usageSymbol];
}
export function extendWithUsage(original, extension) {
    if (!(usageSymbol in original)) {
        return {
            ...original,
            ...extension
        };
    }
    const result = {
        ...extension
    };
    for (const key of [
        usageSymbol,
        ...Object.keys(original)
    ]) {
        if (key in result) {
            continue;
        }
        Object.defineProperty(result, key, {
            enumerable: key !== usageSymbol,
            configurable: key !== usageSymbol,
            get() {
                return original[key];
            }
        });
    }
    return result;
}
//# sourceMappingURL=usage.js.map
